import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Swiper from 'swiper/bundle'
import { horizontalLoop } from '../../../src/js/utils/seamlessLoop'

gsap.registerPlugin(ScrollTrigger)

function results() {
    const results = document.querySelector('[data-name="results_grid"]')

    if (results) {
        const resultsPin = document.querySelector('[data-name="results_pin"]')
        const resultsTiles = results.querySelectorAll('[data-target="result"]')
        const resultsTitle = results.querySelector(
            '[data-name="results_title"]'
        )
        const resultsText = results.querySelector('[data-name="results_text"]')
        const translateResults = results.querySelector(
            '[data-name="translate-results"]'
        )
        const resultsIllustrations = results.querySelectorAll(
            '[data-target="results_illustration"]'
        )
        const stats = results.querySelectorAll('[data-target="results_stats"]')

        if (window.innerWidth > 1280) {
            resultsTiles.forEach((tile, index) => {
                const scale = tile.dataset.scale
                const translateY = tile.dataset.translate

                gsap.set(tile, {
                    y: translateY + '%',
                    scale,
                })
            })

            gsap.set(resultsTitle, {
                autoAlpha: 0,
            })

            gsap.set(stats, {
                autoAlpha: 0,
            })

            gsap.set(resultsText, {
                autoAlpha: 0,
            })

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: results,
                    start: 'top top',
                    end: '+=150%',
                    pin: true,
                    scrub: 1,
                    anticipatePin: 1,
                    // markers: document.body.classList.contains('logged-in')
                    //     ? true
                    //     : false,

                    onLeave: (self) => {
                        let start = self.start
                        self.scroll(self.start)
                        self.disable()

                        self.animation.progress(1, true)
                        ScrollTrigger.refresh()
                        window.scrollTo(0, start)
                    },
                },
            })

            tl.to(translateResults, {
                y: '0%',
                duration: 0.25,
            })
                .to(
                    resultsTiles,
                    {
                        y: '0%',
                        duration: 0.25,
                        scale: 1,
                    },
                    '<'
                )
                .to(
                    resultsIllustrations,
                    {
                        scale: 0.5,
                        duration: 0.25,
                        transformOrigin: 'right center',
                    },
                    '<0.1'
                )
                .to(
                    stats,
                    {
                        autoAlpha: 1,
                        duration: 0.1,
                    },
                    '<0.05'
                )
                .to(
                    resultsTitle,
                    {
                        autoAlpha: 1,
                        duration: 0.1,
                    },
                    '<0.15'
                )
                .to(
                    resultsText,
                    {
                        autoAlpha: 1,
                        duration: 0.1,
                    },
                    '<'
                )
        } else {
            const swiper = new Swiper('.results-slider', {
                slidesPerView: 1.25,
                centeredSlides: true,
                initialSlide: 2,
                spaceBetween: 20,
                loop: true,
                pagination: {
                    el: '.swiper-pagination-results',
                    type: 'fraction',
                },
                navigation: {
                    nextEl: '.swiper-button-next-results',
                    prevEl: '.swiper-button-prev-results',
                },
                autoplay: {
                    delay: 4000,
                },
                breakpoints: {
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    821: {
                        slidesPerView: 2.25,
                        spaceBetween: 20,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                },
            })
        }

        function schoolsList() {
            const list = document.querySelector('[data-target="schools-list"]')
            const listItems = list.querySelectorAll('[data-target="box"]')

            const horizontal = horizontalLoop(listItems, { repeat: -1 })

            list.addEventListener('mouseenter', () => {
                horizontal.pause()
            })

            list.addEventListener('mouseleave', () => {
                horizontal.play()
            })
        }

        schoolsList()
    }

    ScrollTrigger.refresh()
}

export default results
